import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import {
    SuggestionCommitteeAccess,
    SuggestionCommitteeService,
} from '@masar/core/services';
import { NotificationService } from 'mnm-webapp';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class SuggestionCommitteeAccessGuard {
    public constructor(
        private readonly suggestionCommitteeService: SuggestionCommitteeService,
        private readonly router: Router,
        private readonly notificationService: NotificationService,
        private readonly translateService: TranslateService
    ) {}

    public canActivate(
        activatedRoute: ActivatedRouteSnapshot,
        _: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        const accessKey: keyof SuggestionCommitteeAccess =
            activatedRoute.data['suggestionCommitteeAccess'] ||
            'canManageCommittee';

        return this.suggestionCommitteeService.getAccess().pipe(
            map(access => access[accessKey]),
            tap(hasAccess => {
                if (!hasAccess) {
                    this.router.navigate(['']).then();
                    this.translateService
                        .get(
                            'translate_you_do_not_have_the_permission_to_access_this_page'
                        )
                        .subscribe(str => {
                            this.notificationService.notifyError(str);
                        });
                }
            })
        );
    }
}
